{
  "version": 1,
  "asset_id": "b292f911-55de-42bd-a2f2-e926a0492050",
  "project_id": "93ebf89f-7c73-440e-8d33-7be2cf392b2d",
  "url": "/__l5e/assets-v1/b292f911-55de-42bd-a2f2-e926a0492050/g17.jpg",
  "r2_key": "a/v1/93ebf89f-7c73-440e-8d33-7be2cf392b2d/b292f911-55de-42bd-a2f2-e926a0492050/g17.jpg",
  "original_filename": "g17.jpg",
  "size": 942135,
  "content_type": "image/jpeg",
  "created_at": "2026-07-02T22:52:58Z"
}
